// extracted by mini-css-extract-plugin
export default {"StickyBlock":"bel_a bhl_bj"};